import React from "react";

interface IFilterContextAnalytics {
  changed?: string;
}

interface IFilterContext {
  filterState?: any;
  setFilterState?: any;
  setDirty?: any;
  analytics: IFilterContextAnalytics;
}

export const FilterContext = React.createContext<IFilterContext>({ analytics: {} });
